module.exports = __webpack_public_path__ + "img/tag.fc9c7ffe.svg";